import React, { useState, useEffect, useMemo, useCallback } from 'react';
import './index.scss';
import { ProductAuthorityFeature, apis, apiHolder } from 'api';
import { comIsShowByAuth } from '@web-common/utils/utils';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import { useGetOrgInfo } from '@web-common/hooks/useGetOrgInfo';
import { Collapse, Modal, Button, message } from 'antd';
import debounce from 'lodash/debounce';
import DownArrowIcon from '@/images/icons/arrow-down-1.svg';
import UpArrowIcon from '@/images/icons/arrow-up-1.svg';
import FalseProductIcon from '@/images/icons/product_icon_false.svg';
import TrueProductIcon from '@/images/icons/product_icon_true.svg';
import { ReactComponent as CloseIcon } from '@/images/icons/close_modal.svg';
import { getIn18Text } from 'api';
const { Panel } = Collapse;
const productAuthApi = apiHolder.api.requireLogicalApi(apis.productAuthApiImpl);
const openObj = {};
const Product = props => {
    const { productVisible, cancelMed, onUpgradeModel } = props;
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const { orgInfo: { sys_type }, } = useGetOrgInfo();
    const [height, setHeight] = useState(0);
    const [originData, setOriginData] = useState([]);
    const [openPanel, setOpenPanel] = useState(openObj);
    const versionTag = useMemo(() => {
        if (sys_type === 1) {
            return getIn18Text('GUOJIHUABAN');
        }
        return getIn18Text('DANGQIANBANBEN');
    }, [sys_type]);
    const handleResize = useCallback(debounce(() => {
        const vh = document.body.clientHeight;
        if (typeof window !== undefined) {
            if (vh > 810) {
                setHeight(540);
            }
            else {
                setHeight(vh - 64 * 2 - 136);
            }
        }
    }), []);
    useEffect(() => {
        productAuthApi
            .doGetProductTags()
            .then(res => {
            setOriginData(res.tags);
        })
            .catch(err => {
            message.error('获取版本信息失败');
        });
    }, []);
    useEffect(() => {
        originData.forEach((item, i) => {
            openObj[i] = false;
        });
        setOpenPanel(openObj);
    }, [originData]);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            handleResize();
            window.addEventListener('resize', handleResize);
        }
        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', handleResize);
            }
        };
    }, [handleResize]);
    useEffect(() => {
        if (productVisible) {
            for (const i in openObj) {
                openObj[i] = false;
            }
            setOpenPanel(openObj);
        }
    }, [productVisible]);
    const setDirectIcon = (direct, fun) => {
        if (direct == null) {
            return React.createElement("span", null);
        }
        switch (direct) {
            case '0':
                return React.createElement("img", { className: "content-span-big", src: FalseProductIcon, alt: "arrow-right" });
            case '1':
                return React.createElement("img", { className: "content-span-big", src: TrueProductIcon, alt: "arrow-right" });
            default:
                const strArr = direct.split('-');
                if (strArr.length === 1) {
                    return React.createElement("span", { style: { marginLeft: '4px' } }, direct);
                }
                else {
                    return (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "content-span-inline", style: { marginTop: '4px' } }, strArr[0]),
                        React.createElement("span", { className: "content-span-inline", style: { marginLeft: '-9px' } }, strArr[1])));
                }
        }
    };
    const renderTitle = (item, i) => (React.createElement("div", { className: "content" },
        React.createElement("span", { className: "content-span content-span-func content-span-flex" },
            item.pFunc,
            openPanel[i] ? (React.createElement("img", { className: "content-span-icon", src: UpArrowIcon, alt: "arrow-right" })) : (React.createElement("img", { className: "content-span-icon", src: DownArrowIcon, alt: "arrow-right" }))),
        !openPanel[i] && (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "content-span" }, setDirectIcon(item.pFree)),
            React.createElement("span", { className: "content-span" }, setDirectIcon(item.pPay)),
            React.createElement("span", { className: "content-span" }, setDirectIcon(item.pLingxi))))));
    const changeCollapse = (index, arr) => {
        if (arr.length == 0) {
            setOpenPanel(Object.assign(Object.assign({}, openPanel), { [index]: false }));
        }
        else {
            setOpenPanel(Object.assign(Object.assign({}, openPanel), { [index]: true }));
        }
    };
    return (React.createElement(React.Fragment, null, productVisible && (React.createElement(Modal, { visible: productVisible, onCancel: cancelMed, wrapClassName: "product-modal-wrap", centered: true, width: 600, footer: null, closeIcon: React.createElement(CloseIcon, { className: "dark-invert" }) },
        React.createElement("div", { className: "product-version" },
            React.createElement("div", null,
                React.createElement("div", { className: "product-title" }, getIn18Text('WANGYILINGXIBAN13')),
                productVersionId !== 'sirius' && React.createElement("div", { className: "product-update" }, getIn18Text('LIANXININDEZHUAN')),
                React.createElement("div", { className: "product-warp", style: { paddingBottom: productVersionId === 'sirius' ? '24px' : '0px' } },
                    React.createElement("div", { className: "content title" },
                        React.createElement("span", { className: "content-span content-span-flex" }, getIn18Text('GONGNENG')),
                        React.createElement("span", { className: "content-span" },
                            getIn18Text('MIANFEIBAN'),
                            productVersionId === 'free' && React.createElement("span", { className: "content-span-tag" }, versionTag)),
                        React.createElement("span", { className: "content-span" },
                            getIn18Text('QIJIANBAN'),
                            productVersionId === 'ultimate' && React.createElement("span", { className: "content-span-tag" }, versionTag)),
                        React.createElement("span", { className: "content-span" },
                            getIn18Text('ZUNXIANGBAN'),
                            productVersionId === 'sirius' && React.createElement("span", { className: "content-span-tag" }, versionTag))),
                    React.createElement("div", { className: "version-warp-content ant-allow-dark", style: { height } }, originData.map((json, i) => (React.createElement(Collapse, { className: "content-collapse", onChange: changeCollapse.bind(this, i) },
                        React.createElement(Panel, { showArrow: false, header: renderTitle(json, i), key: i, className: "site-collapse-custom-panel" }, json.children.map((item, j) => (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: `content ${j % 2 == 0 ? 'content-row' : null}`, key: j },
                                React.createElement("span", { className: "content-span content-span-font content-span-flex" },
                                    React.createElement("span", null,
                                        item.func,
                                        item.titleInfo && React.createElement("span", { style: { color: 'rgba(168, 170, 173, 1)', paddingLeft: '4px' } },
                                            "(",
                                            item.titleInfo,
                                            ")"))),
                                React.createElement("span", { className: "content-span content-span-font" }, setDirectIcon(item.free, item.func)),
                                React.createElement("span", { className: "content-span content-span-font" }, setDirectIcon(item.pay, item.func)),
                                React.createElement("span", { className: "content-span content-span-font" }, setDirectIcon(item.lingxi, item.func)))))))))))),
                productVersionId !== 'sirius' ? (React.createElement("div", { className: "product-footer" },
                    React.createElement(Button, { onClick: cancelMed }, getIn18Text('ZHIDAOLE')),
                    comIsShowByAuth(ProductAuthorityFeature.ADMIN_SITE_ENTRANCE_SHOW, React.createElement(Button, { type: "primary", style: { marginLeft: '12px' }, onClick: onUpgradeModel }, getIn18Text('TAOCANSHENGJI'))))) : null))))));
};
export default Product;
